import {create} from 'zustand';
import { exportChatMessage } from '../repositories/agentService';
import { downloadPDFReport } from '../repositories/exports/fileExports';
import useSchoolStore from './schoolStore';
import useUserStore from './userStore';
import useAuthStore from './authStore';

const useExportStore = create((set) => ({
  loading: false,
  error: null,
  
  generatePDF: async (params) => {
    const {schoolData} = useSchoolStore.getState();
    const {userToken} = useAuthStore.getState();

    set({ loading: true, error: null });
    try {
      const result = await exportChatMessage({
        schoolId: schoolData.id,
        userToken,
        messageId: params.messageId,
        reportId: params.reportId,
        reportName: params.reportName,
        type: params.type,
        schoolData,
        iconUrl: schoolData.iconUrl,
      });
      if (!result.success) {
        throw new Error(result.message);
      }
      
      const blob = result.value;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${params.reportName || 'askme-response'}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      set({ loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  downloadPDF: async (data, fileName) => {
    set({ loading: true, error: null });
    try {
      const result = await downloadPDFReport(data);
      if (!result.success) {
        throw new Error(result.message);
      }
      
      const blob = result.value;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName || 'report'}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      set({ loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
  
  reset: () => set({ loading: false, error: null }),
}));

export default useExportStore;

